import { defineComponent } from 'vue';
import { getBegateway, checkCard, UrlService, keys as keys$1, EncryptService, Utilities } from '@onlinerby/common';
import creditCardType from 'credit-card-type';
import moment from 'moment';
import $$1 from 'jquery';
import { isNaN as isNaN$1, contains } from 'underscore';
import { CobrandCard, paygateApi } from '@onlinerby/api-clients';

var script = defineComponent({
    name: 'payments-card-description',
});

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)};
var __vue_staticRenderFns__ = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-form__description auth-form__description_primary auth-form__description_base auth-form__description_condensed-complementary"},[_vm._v("\n  Обработка платежей по банковским картам и их хранение\n  осуществляется через систему электронных платежей\n  "),_c('a',{attrs:{"href":"https://bepaid.by/","target":"_blank"}},[_vm._v("bePaid")]),_vm._v(", которая отвечает\n  всем требованиям безопасности передачи данных (PCI DSS Level 1).\n")])}];

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var PaymentsCardDescription = normalizeComponent_1(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var map = {
    master: {
        name: 'MasterCard',
        logo: 'mastercard',
        typeCode: 'MASTERCARD',
    },
    maestro: {
        name: 'Maestro',
        logo: 'maestrocard',
        typeCode: 'MAESTRO',
    },
    visa: {
        name: 'VISA',
        logo: 'visa',
        typeCode: 'VISA',
    },
    belkart: {
        name: 'БЕЛКАРТ',
        logo: 'belcard',
        typeCode: 'BELCARD',
    },
    jcb: {
        name: 'JCB',
        logo: 'jcb',
        typeCode: 'JCB',
    },
    unionpay: {
        name: 'China UnionPay',
        logo: 'china-unionpay',
        typeCode: 'UNIONPAY',
    },
    amex: {
        name: 'AMERICAN EXPRESS',
        logo: 'american-express',
        typeCode: 'AMERICAN_EXPRESS',
    },
    cirrus: {
        name: 'Cirrus',
        logo: 'cirrus',
        typeCode: 'CIRRUS',
    },
};

var TheMask = require('vue-the-mask').TheMask;
var defaultType = {
    code: {
        size: 3,
        name: 'CVV',
    },
    placeholder: '000',
};
var script$1 = defineComponent({
    name: 'payments-list-card',
    components: {
        TheMask: TheMask,
        PaymentsCardDescription: PaymentsCardDescription,
    },
    props: {
        card: {
            type: Object,
            required: true,
        },
        value: {
            type: Object,
            required: true,
        },
        publicKey: {
            type: String,
            required: true,
        },
        hide: {
            type: Object,
            default: function () { return ({}); },
        },
    },
    data: function data() {
        return {
            type: defaultType,
            cvcNumber: '',
            cvcError: '',
        };
    },
    created: function created() {
        this.type = this.getCardType();
    },
    computed: {
        selectedMethod: {
            get: function get() {
                return Object.assign({}, this.value);
            },
            set: function set(value) {
                this.$emit('input', value);
            },
        },
    },
    methods: {
        onCvcInput: function onCvcInput() {
            this.cvcError = '';
        },
        getCardType: function getCardType() {
            var type = map[this.card.fields.brand];
            if (!type) {
                return defaultType;
            }
            var ccType = creditCardType.types[type.typeCode];
            return ccType ? creditCardType.getTypeInfo(ccType) : defaultType;
        },
        validate: function validate() {
            if (!this.card.isCvvNeeded) {
                return true;
            }
            if (!this.cvcNumber) {
                this.cvcError = 'Введите CVC/CVV';
                return false;
            }
            if (this.cvcNumber.length !== this.type.code.size ||
                !/^\d+$/.test(this.cvcNumber)) {
                this.cvcError = 'Некорректный код';
                return false;
            }
            return true;
        },
        getVerificationValue: function getVerificationValue(callback) {
            var this$1 = this;

            if (!this.card.isCvvNeeded) {
                callback(null);
                return;
            }
            getBegateway(this.publicKey, function (begateway) {
                document.querySelectorAll('[name^="encrypted"]').forEach(function (item) {
                    item.remove();
                });
                begateway.encrypt(("begateway-encrypted-form_" + (this$1.card.cardId)));
                var $cvcInput = document.querySelectorAll(("[name=\"encrypted_verification_value_" + (this$1.card.cardId) + "\"]"))[0];
                callback($cvcInput.value);
            });
        },
    },
});

/* script */
var __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"auth-form__choise-unit",class:{ 'auth-form__choise-unit_alter': _vm.card.isExpired }},[_c('div',{staticClass:"auth-checkbox auth-checkbox_radio auth-checkbox_success auth-form__checkbox auth-form__checkbox_base",class:{ 'auth-checkbox_disabled': _vm.card.isExpired }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMethod),expression:"selectedMethod"}],staticClass:"auth-checkbox__real",attrs:{"type":"radio","name":"active-payment-method","disabled":_vm.card.isExpired},domProps:{"value":_vm.card,"checked":_vm._q(_vm.selectedMethod,_vm.card)},on:{"change":function($event){_vm.selectedMethod=_vm.card;}}}),_vm._v(" "),_c('span',{staticClass:"auth-checkbox__faux"}),_vm._v(" "),_c('div',{staticClass:"auth-form__choise-item",class:{ 'auth-form__choise-item_disabled': _vm.card.isExpired }},[_c('div',{staticClass:"auth-form__choise-header"},[_c('div',{staticClass:"auth-form__preview"},[_c('div',{staticClass:"auth-form__image",class:['auth-form__image_' + (_vm.card.cardInfo.logo || 'empty')]})]),_vm._v(" "),_c('div',{staticClass:"auth-form__description auth-form__description_primary auth-form__description_base auth-form__description_condensed"},[_c('span',{staticClass:"auth-form__description auth-form__description_primary auth-form__description_base auth-form__description_font-weight_semibold"},[_vm._v(_vm._s(_vm.card.cardInfo.name))]),_vm._v("\n           • \n          "+_vm._s(_vm.card.fields.last_4)+" \n          "),_c('span',{staticClass:"auth-form__description auth-form__description_tiny",class:[
              _vm.card.isExpired
                ? 'auth-form__description_error'
                : 'auth-form__description_secondary' ]},[_vm._v("до "+_vm._s(_vm.card.expires))]),_vm._v(" "),(_vm.card.isExpired)?_c('span',{staticClass:"auth-form__description auth-form__description_error auth-form__description_tiny"},[_vm._v("— срок истек")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"auth-form__choise-body",attrs:{"id":("begateway-encrypted-form_" + (_vm.card.cardId))}},[(_vm.card.isCvvNeeded && !_vm.hide.cardCvv)?_c('div',{staticClass:"auth-form__cardbox"},[_c('div',{staticClass:"auth-form__row auth-form__row_condensed"},[_c('div',{staticClass:"auth-form__group auth-form__group_wide-alter"},[_c('div',{staticClass:"auth-form__field"},[_c('div',{staticClass:"auth-form__field-flex"},[_c('div',{staticClass:"auth-form__field-part auth-form__field-part_1"},[_c('div',{staticClass:"auth-form__hint auth-form__hint_secondary auth-form__hint_base auth-form__hint_cvc auth-form__hint_extended-alter auth-form__hint_narrow auth-form__hint_nonadaptive"}),_vm._v(" "),_c('div',{staticClass:"auth-input__wrapper auth-form__input-wrapper auth-form__input-wrapper_width_xxxxssss auth-form__input-wrapper_nonadaptive"},[_c('the-mask',{ref:"cvc",staticClass:"auth-input auth-input_primary auth-input_small auth-input_text_center auth-form__input auth-form__input_width_full",class:{ 'input-style_error': _vm.cvcError },attrs:{"type":"password","autocomplete":"cc-csc","mask":[_vm.type.code.size === 3 ? '###' : '####'],"placeholder":_vm.type.code.name,"size":_vm.type.code.size,"maxlength":_vm.type.code.size,"data-encrypted-name":("encrypted_verification_value_" + (_vm.card.cardId))},on:{"input":_vm.onCvcInput},model:{value:(_vm.cvcNumber),callback:function ($$v) {_vm.cvcNumber=$$v;},expression:"cvcNumber"}})],1)]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),(_vm.cvcError)?_c('div',{staticClass:"auth-form__description auth-form__description_error auth-form__description_base auth-form__description_fail"},[_c('div',{staticClass:"auth-form__description auth-form__description_error auth-form__description_base auth-form__description_condensed-alter"},[_vm._v("\n                    "+_vm._s(_vm.cvcError)+"\n                  ")])]):_vm._e()])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"auth-form__choise-group"},[_vm._m(1),_vm._v(" "),_c('payments-card-description')],1)])])])])};
var __vue_staticRenderFns__$1 = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-form__field-part auth-form__field-part_2"},[_c('div',{staticClass:"auth-form__description auth-form__description_other auth-form__description_tiny"},[_vm._v("\n                      Карта не поддерживает автоплатежи\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-form__preview"},[_c('div',{staticClass:"auth-form__image auth-form__image_bepaid"})])}];

  /* style */
  var __vue_inject_styles__$1 = undefined;
  /* scoped */
  var __vue_scope_id__$1 = undefined;
  /* module identifier */
  var __vue_module_identifier__$1 = undefined;
  /* functional template */
  var __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var PaymentsListCard = normalizeComponent_1(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

function price (value, fixed) {
    if ( fixed === void 0 ) fixed = 2;

    var floatValue = parseFloat(value.toString().replace(',', '.'));
    if (isNaN(floatValue)) {
        return NaN;
    }
    var ref = floatValue.toString().split('.');
    var decimal = ref[0];
    var float = ref[1];
    return float ? [decimal, float].join('.') : (decimal + "." + ('0'.repeat(fixed)));
}

function money (value) {
    return price(value, 2).toString().replace('.', ',');
}

var script$2 = defineComponent({
    name: 'payments-list-item',
    filters: {
        money: money,
    },
    props: {
        method: {
            type: Object,
            required: true,
        },
        value: {
            type: Object,
            required: true,
        },
    },
    computed: {
        selectedMethod: {
            get: function get() {
                return Object.assign({}, this.value);
            },
            set: function set(value) {
                this.$emit('input', value);
            },
        },
    },
});

/* script */
var __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"auth-form__choise-unit"},[_c('div',{staticClass:"auth-checkbox auth-checkbox_radio auth-checkbox_success auth-form__checkbox auth-form__checkbox_base"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMethod),expression:"selectedMethod"}],staticClass:"auth-checkbox__real",attrs:{"type":"radio","name":"active-payment-method"},domProps:{"value":_vm.method,"checked":_vm._q(_vm.selectedMethod,_vm.method)},on:{"change":function($event){_vm.selectedMethod=_vm.method;}}}),_vm._v(" "),_c('span',{staticClass:"auth-checkbox__faux"}),_vm._v(" "),_c('div',{staticClass:"auth-form__choise-item"},[_c('div',{staticClass:"auth-form__choise-header"},[_c('div',{staticClass:"auth-form__description auth-form__description_primary auth-form__description_base auth-form__description_condensed"},[_c('span',{staticClass:"auth-form__description auth-form__description_primary auth-form__description_base auth-form__description_font-weight_semibold"},[_vm._v("\n            "+_vm._s(_vm.method.title)+" ")]),(_vm.method.fields && _vm.method.fields.balance)?_c('span',[_vm._v(" • "+_vm._s(_vm._f("money")(_vm.method.fields.balance.amount))+" р.")]):_vm._e(),_vm._v(" "),_vm._t("fee")],2),_vm._v(" "),_c('div',{staticClass:"auth-form__description auth-form__description_tiny"},[_vm._t("subheader")],2)]),_vm._v(" "),_c('div',{staticClass:"auth-form__choise-body"},[_c('div',{staticClass:"auth-form__choise-group"},[_c('div',{staticClass:"auth-form__preview"},[_c('div',{staticClass:"auth-form__image",class:'auth-form__image_' + _vm.method.name})]),_vm._v(" "),_c('div',{staticClass:"auth-form__description auth-form__description_primary auth-form__description_base auth-form__description_font-weight_semibold auth-form__description_condensed"},[_vm._v("\n            Как платить?\n          ")]),_vm._v(" "),_vm._t("description")],2),_vm._v(" "),_c('div',{staticClass:"auth-form__description auth-form__description_primary auth-form__description_base auth-form__description_condensed"},[_vm._t("summary")],2)])])])])};
var __vue_staticRenderFns__$2 = [];

  /* style */
  var __vue_inject_styles__$2 = undefined;
  /* scoped */
  var __vue_scope_id__$2 = undefined;
  /* module identifier */
  var __vue_module_identifier__$2 = undefined;
  /* functional template */
  var __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var PaymentsListItem = normalizeComponent_1(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    undefined,
    undefined
  );

var defaultCardType = {
    code: {
        size: 3,
        name: 'CVV',
    },
    placeholder: '000',
};
var p2pExcludedCards = ['halva'];

var CardDataMixin = defineComponent({
    data: function data() {
        return {
            type: defaultCardType,
            isTermsAgreed: true,
            month: '',
            year: '',
            fullYear: '',
            unmaskedCreditCardNumber: '',
            cvcNumber: '',
            errors: [],
            isCardNumberError: false,
            isMonthError: false,
            isYearError: false,
            isCvcError: false,
            isMainErrorActive: false,
            secure3dUrl: '',
            isProcessing: false,
        };
    },
});

var CardEncryptMixin = defineComponent({
    name: 'card-encrypt-mixin',
    props: {
        publicKey: {
            type: String,
            required: true,
        },
    },
    methods: {
        getEncryptedData: function getEncryptedData(callback) {
            getBegateway(this.publicKey, function (begateway) {
                document.querySelectorAll('[name^="encrypted"]').forEach(function (item) {
                    item.remove();
                });
                begateway.encrypt('begateway-encrypted-form');
                var data = {
                    number: document.querySelectorAll('[name="encrypted_number"]')[0].value,
                    exp_month: document.querySelectorAll('[name="encrypted_exp_month"]')[0].value,
                    exp_year: document.querySelectorAll('[name="encrypted_exp_year"]')[0].value,
                    verification_value: document.querySelectorAll('[name="encrypted_verification_value"]')[0].value,
                };
                callback && callback(data);
            });
        },
    },
});

var CardInputsMixin = defineComponent({
    name: 'card-inputs',
    mixins: [CardDataMixin],
    methods: {
        onCardNumberInput: function onCardNumberInput() {
            var this$1 = this;

            this.isCardNumberError = false;
            this.type =
                creditCardType(this.unmaskedCreditCardNumber.slice(0, 4))[0] ||
                    defaultCardType;
            this.type.code.size === 3
                ? (this.type.placeholder = '000')
                : (this.type.placeholder = '0000');
            if (this.unmaskedCreditCardNumber.length > 15) {
                setTimeout(function () {
                    this$1.$refs.month.$el.focus();
                }, 0);
            }
        },
        onMonthInput: function onMonthInput() {
            var this$1 = this;

            this.isMonthError = false;
            if (this.month.length === 2) {
                setTimeout(function () {
                    this$1.$refs.year.$el.focus();
                }, 0);
            }
        },
        onYearInput: function onYearInput() {
            var this$1 = this;

            this.isYearError = false;
            this.fullYear = '20' + this.year;
            if (this.year.length === 2) {
                setTimeout(function () {
                    this$1.$refs.cvc.$el.focus();
                }, 0);
            }
        },
        onCvcInput: function onCvcInput() {
            this.isCvcError = false;
        },
    },
});

var errorsTexts = {
    expired: 'Срок действия карты истек',
    noData: 'Введите данные карты',
    emptyCvc: 'Введите CVC/CVV',
    incorrectNumber: 'Некорректный номер карты',
    incorrectCvc: 'Некорректный код',
    incorrectDate: 'Некорректная дата',
};
var CardValidationsMixin = defineComponent({
    name: 'card-validation',
    data: function data() {
        return {
            isMainErrorActive: false,
            errors: [],
            isCardNumberError: false,
            isMonthError: false,
            isYearError: false,
            isCvcError: false,
            unmaskedCreditCardNumber: '',
            cvcNumber: '',
            month: '',
            year: '',
            fullYear: '',
            type: {
                code: {
                    size: 3,
                },
            },
        };
    },
    methods: {
        validateData: function validateData() {
            this.isMainErrorActive = false;
            this.errors = [];
            this.isCardNumberError = false;
            this.isMonthError = false;
            this.isYearError = false;
            this.isCvcError = false;
            if (!this.unmaskedCreditCardNumber.length ||
                !this.cvcNumber.length ||
                !this.month.length ||
                !this.year.length ||
                !/^\d+$/.test(this.unmaskedCreditCardNumber)) {
                this.errors.indexOf(errorsTexts.noData) === -1 &&
                    this.errors.push(errorsTexts.noData);
                this.isMainErrorActive = true;
            }
            if (this.unmaskedCreditCardNumber.length !== 16 ||
                !/^\d+$/.test(this.unmaskedCreditCardNumber) ||
                !checkCard(this.unmaskedCreditCardNumber)) {
                this.isCardNumberError = true;
                this.unmaskedCreditCardNumber.length &&
                    this.errors.indexOf(errorsTexts.incorrectNumber) === -1 &&
                    this.errors.push(errorsTexts.incorrectNumber);
            }
            if (this.month.length !== 2 ||
                !/^\d+$/.test(this.month) ||
                parseFloat(this.month) > 12 ||
                this.month === '00') {
                this.isMonthError = true;
                this.month.length &&
                    this.errors.indexOf(errorsTexts.incorrectDate) === -1 &&
                    this.errors.push(errorsTexts.incorrectDate);
            }
            if (this.year.length !== 2 || !/^\d+$/.test(this.year)) {
                this.isYearError = true;
                this.year.length &&
                    this.errors.indexOf(errorsTexts.incorrectDate) === -1 &&
                    this.errors.push(errorsTexts.incorrectDate);
            }
            if (!this.cvcNumber) {
                this.isCvcError = true;
                this.cvcNumber.length &&
                    this.errors.indexOf(errorsTexts.emptyCvc) === -1 &&
                    this.errors.push(errorsTexts.emptyCvc);
            }
            else if (this.cvcNumber.length !== this.type.code.size ||
                !/^\d+$/.test(this.cvcNumber)) {
                this.isCvcError = true;
                this.cvcNumber.length &&
                    this.errors.indexOf(errorsTexts.incorrectCvc) === -1 &&
                    this.errors.push(errorsTexts.incorrectCvc);
            }
            if (moment(moment().format('YYYY-MM')).isAfter(this.fullYear + '-' + this.month, 'month') &&
                this.month.length === 2 &&
                this.year.length === 2) {
                this.isMonthError = true;
                this.isYearError = true;
                this.errors.indexOf(errorsTexts.expired) === -1 &&
                    this.errors.push(errorsTexts.expired);
            }
            return this.errors;
        },
    },
});

var TheMask$1 = require('vue-the-mask').TheMask;
var script$3 = defineComponent({
    name: 'card-form',
    components: {
        TheMask: TheMask$1,
    },
    mixins: [
        CardEncryptMixin,
        CardInputsMixin,
        CardValidationsMixin,
        CardDataMixin ],
    props: {
        isCompact: {
            type: Boolean,
            default: false,
        },
        isNarrow: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        getPristineData: function getPristineData(success, error) {
            this.validateData();
            if (this.errors.length) {
                error && error(this.errors);
                this.scrollToError();
                return;
            }
            success({
                number: this.unmaskedCreditCardNumber,
                expMonth: this.month,
                expYear: this.fullYear,
                verificationValue: this.cvcNumber,
            });
        },
        getData: function getData(success, error) {
            this.validateData();
            if (this.errors.length) {
                error && error(this.errors);
                return;
            }
            this.getEncryptedData(function (data) {
                success(data);
            });
        },
        scrollToError: function scrollToError() {
            this.$nextTick(function () {
                var anchor = document.querySelector('.input-style_error');
                anchor && anchor.scrollIntoView();
            });
        },
    },
});

/* script */
var __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-form__cardbox-list",attrs:{"id":"begateway-encrypted-form"}},[_c('div',{staticClass:"auth-form__cardbox-item"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"auth-form__row auth-form__row_condensed-other"},[_c('div',{staticClass:"auth-form__group auth-form__group_wide-alter",class:{ 'auth-form__group_nonadaptive': !_vm.isCompact }},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"auth-form__field"},[_c('div',{staticClass:"auth-input__wrapper auth-form__input-wrapper auth-form__input-wrapper_narrow"},[_c('the-mask',{staticClass:"input-style input-style_primary input-style_base auth-form__input auth-form__input_width_ssm",class:{
                'input-style_error': _vm.isCardNumberError,
                'input-style_disabled': _vm.isProcessing,
                'auth-form__input_nonadaptive': !_vm.isCompact,
              },attrs:{"type":"tel","mask":['#### #### #### ####'],"placeholder":"0000  0000  0000  0000","autocomplete":"cc-number"},on:{"input":_vm.onCardNumberInput},model:{value:(_vm.unmaskedCreditCardNumber),callback:function ($$v) {_vm.unmaskedCreditCardNumber=$$v;},expression:"unmaskedCreditCardNumber"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.unmaskedCreditCardNumber),expression:"unmaskedCreditCardNumber"}],attrs:{"type":"hidden","data-encrypted-name":"encrypted_number"},domProps:{"value":(_vm.unmaskedCreditCardNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.unmaskedCreditCardNumber=$event.target.value;}}})],1)])]),_vm._v(" "),_c('div',{staticClass:"auth-form__group auth-form__group_wide-alter auth-form__group_nonadaptive"},[(!_vm.isNarrow)?_c('div',{staticClass:"auth-form__label auth-form__label_primary auth-form__label_base auth-form__label_font-weight_semibold",class:{ helpers_hide_tablet: _vm.isCompact }},[_c('div',{staticClass:"auth-form__label-flex"},[_c('div',{staticClass:"auth-form__label-part auth-form__label-part_1"},[_c('div',{staticClass:"auth-form__label-title"},[_vm._v(_vm._s(_vm.type.code.name))])]),_vm._v(" "),_vm._m(2)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"auth-form__field"},[_c('div',{staticClass:"auth-input__wrapper auth-form__input-wrapper auth-form__input-wrapper_narrow auth-form__input-wrapper_nonadaptive"},[_c('the-mask',{ref:"cvc",staticClass:"input-style input-style_primary input-style_base auth-form__input auth-form__input_width_xxxxsssmm auth-form__input_nonadaptive",class:{
                'input-style_error': _vm.isCvcError,
                'input-style_disabled': _vm.isProcessing,
              },attrs:{"type":"password","mask":[_vm.type.code.size === 3 ? '###' : '####'],"placeholder":_vm.type.placeholder,"size":_vm.type.code.size,"maxlength":_vm.type.code.size,"autocomplete":"cc-csc","data-encrypted-name":"encrypted_verification_value"},on:{"input":_vm.onCvcInput},model:{value:(_vm.cvcNumber),callback:function ($$v) {_vm.cvcNumber=$$v;},expression:"cvcNumber"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"auth-form__row auth-form__row_condensed-other"},[_c('div',{staticClass:"auth-form__group auth-form__group_wide-alter auth-form__group_nonadaptive"},[_c('div',{staticClass:"auth-form__field"},[_c('div',{staticClass:"auth-input__wrapper auth-form__input-wrapper auth-form__input-wrapper_narrow auth-form__input-wrapper_nonadaptive"},[_c('the-mask',{ref:"month",staticClass:"input-style input-style_primary input-style_base auth-form__input auth-form__input_width_xxxxssss auth-form__input_nonadaptive",class:{
                'input-style_error': _vm.isMonthError,
                'input-style_disabled': _vm.isProcessing,
              },attrs:{"type":"tel","mask":['##'],"placeholder":"ММ","size":"2","maxlength":"2","autocomplete":"cc-exp-month","data-encrypted-name":"encrypted_exp_month"},on:{"input":_vm.onMonthInput},model:{value:(_vm.month),callback:function ($$v) {_vm.month=$$v;},expression:"month"}})],1),_vm._v(" "),_c('div',{staticClass:"auth-form__hint auth-form__hint_alter auth-form__hint_base-alter auth-form__hint_extended auth-form__hint_narrow auth-form__hint_nonadaptive"},[_vm._v("\n            /\n          ")]),_vm._v(" "),_c('div',{staticClass:"auth-input__wrapper auth-form__input-wrapper auth-form__input-wrapper_narrow auth-form__input-wrapper_nonadaptive"},[_c('the-mask',{ref:"year",staticClass:"input-style input-style_primary input-style_base auth-form__input auth-form__input_width_xxxxssss auth-form__input_nonadaptive",class:{
                'input-style_error': _vm.isYearError,
                'input-style_disabled': _vm.isProcessing,
              },attrs:{"type":"tel","mask":['##'],"placeholder":"ГГ","size":"2","maxlength":"2","autocomplete":"cc-exp-year"},on:{"input":_vm.onYearInput},model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v;},expression:"year"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fullYear),expression:"fullYear"}],attrs:{"type":"hidden","data-encrypted-name":"encrypted_exp_year"},domProps:{"value":(_vm.fullYear)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fullYear=$event.target.value;}}})],1)])])])])])};
var __vue_staticRenderFns__$3 = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-form__preview"},[_c('div',{staticClass:"auth-form__image auth-form__image_visa"}),_vm._v(" "),_c('div',{staticClass:"auth-form__image auth-form__image_mastercard"}),_vm._v(" "),_c('div',{staticClass:"auth-form__image auth-form__image_maestrocard"}),_vm._v(" "),_c('div',{staticClass:"auth-form__image auth-form__image_belcard"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-form__label auth-form__label_primary auth-form__label_base auth-form__label_font-weight_semibold"},[_c('div',{staticClass:"auth-form__label-flex"},[_c('div',{staticClass:"auth-form__label-part auth-form__label-part_1"},[_c('div',{staticClass:"auth-form__label-title"},[_vm._v("Номер карты")])]),_vm._v(" "),_c('div',{staticClass:"auth-form__label-part auth-form__label-part_2"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-form__label-part auth-form__label-part_2"},[_c('div',{staticClass:"auth-tooltip__handle auth-tooltip__handle_interactive auth-form__tooltip-handle"},[_c('div',{staticClass:"auth-tooltip auth-tooltip_primary auth-tooltip_base auth-tooltip_top-right auth-tooltip_text_left auth-form__tooltip auth-form__tooltip_min-width_ssm"},[_c('div',{staticClass:"auth-tooltip__content"},[_vm._v("\n                    Код с обратной стороны карты\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"auth-form__tooltip-trigger auth-form__tooltip-trigger_qmark"})])])}];

  /* style */
  var __vue_inject_styles__$3 = undefined;
  /* scoped */
  var __vue_scope_id__$3 = undefined;
  /* module identifier */
  var __vue_module_identifier__$3 = undefined;
  /* functional template */
  var __vue_is_functional_template__$3 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var CardForm = normalizeComponent_1(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    undefined,
    undefined
  );

var script$4 = defineComponent({
    name: 'payments-add-card',
    components: {
        CardForm: CardForm,
        PaymentsCardDescription: PaymentsCardDescription,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        method: {
            type: Object,
            required: true,
        },
        errors: {
            type: Array,
            default: function () { return []; },
        },
        isRulesAccepted: {
            type: Boolean,
            required: true,
        },
        publicKey: {
            type: String,
            required: true,
        },
    },
    data: function data() {
        return {
            cardErrors: [],
        };
    },
    computed: {
        selectedMethod: {
            get: function get() {
                return Object.assign({}, this.value);
            },
            set: function set(value) {
                this.$emit('input', value);
            },
        },
        isAccepted: {
            get: function get() {
                return this.isRulesAccepted;
            },
            set: function set(value) {
                this.$emit('accepted-change', value);
            },
        },
    },
    watch: {
        errors: function errors(value) {
            this.cardErrors = value;
        },
    },
    methods: {
        validateCard: function validateCard() {
            this.cardErrors = this.$refs.cardForm.validateData();
            return this.cardErrors;
        },
        getCardData: function getCardData(callback) {
            this.$refs.cardForm.getData(callback);
        },
    },
});

/* script */
var __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"auth-form__choise-unit"},[_c('div',{staticClass:"auth-checkbox auth-checkbox_radio auth-checkbox_success auth-form__checkbox auth-form__checkbox_base"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMethod),expression:"selectedMethod"}],staticClass:"auth-checkbox__real",attrs:{"type":"radio","name":"active-payment-method"},domProps:{"value":_vm.method,"checked":_vm._q(_vm.selectedMethod,_vm.method)},on:{"change":function($event){_vm.selectedMethod=_vm.method;}}}),_vm._v(" "),_c('span',{staticClass:"auth-checkbox__faux"}),_vm._v(" "),_c('div',{staticClass:"auth-form__choise-item"},[_c('div',{staticClass:"auth-form__choise-header"},[_c('div',{staticClass:"auth-form__description auth-form__description_primary auth-form__description_base auth-form__description_font-weight_semibold auth-form__description_condensed"},[_c('span',[_vm._v(_vm._s(_vm.method.title))]),_vm._v(" \n          "),_vm._t("fee")],2)]),_vm._v(" "),_c('div',{staticClass:"auth-form__choise-body"},[_c('div',{staticClass:"auth-form__cardbox auth-form__cardbox_alter"},[_c('div',{staticClass:"auth-form__description auth-form__description_other auth-form__description_tiny"},[_vm._v("\n            После оплаты карта сохранится у вас в профиле, вы сможете\n            совершать платежи в один клик\n          ")]),_vm._v(" "),_c('card-form',{ref:"cardForm",attrs:{"public-key":_vm.publicKey,"is-compact":true}}),_vm._v(" "),_c('div',{staticClass:"auth-form__row auth-form__row_extended-specific"},[_c('div',{staticClass:"auth-form__group auth-form__group_width_full"},[_c('div',{staticClass:"auth-form__field"},[_c('label',{staticClass:"auth-form__checkbox-label"},[_c('span',{staticClass:"auth-checkbox auth-form__checkbox auth-form__checkbox_base"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isAccepted),expression:"isAccepted"}],staticClass:"auth-checkbox__real",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isAccepted)?_vm._i(_vm.isAccepted,null)>-1:(_vm.isAccepted)},on:{"change":function($event){var $$a=_vm.isAccepted,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isAccepted=$$a.concat([$$v]));}else {$$i>-1&&(_vm.isAccepted=$$a.slice(0,$$i).concat($$a.slice($$i+1)));}}else {_vm.isAccepted=$$c;}}}}),_vm._v(" "),_c('span',{staticClass:"auth-checkbox__faux"}),_vm._v(" "),_vm._m(0)])])])])]),_vm._v(" "),(_vm.cardErrors.length)?_c('div',{staticClass:"auth-form__description auth-form__description_error auth-form__description_base auth-form__description_fail"},_vm._l((_vm.cardErrors.slice(0, 1)),function(error){return _c('div',{staticClass:"auth-form__description auth-form__description_error auth-form__description_base auth-form__description_condensed-alter"},[_vm._v("\n              "+_vm._s(error)+"\n            ")])}),0):_vm._e(),_vm._v(" "),_vm._m(1)],1),_vm._v(" "),_c('div',{staticClass:"auth-form__choise-group"},[_vm._m(2),_vm._v(" "),_c('payments-card-description')],1)])])])])};
var __vue_staticRenderFns__$4 = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"auth-form__checkbox-text"},[_c('span',{staticClass:"auth-form__checkbox-sign"},[_vm._v("\n                        Я согласен с\n                        "),_c('a',{staticClass:"auth-form__link auth-form__link_primary auth-form__link_base auth-form__link_nodecor",attrs:{"href":"https://blog.onliner.by/usloviya-oplaty/","target":"_blank"}},[_vm._v("правилами")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-form__mediabox"},[_c('div',{staticClass:"auth-form__mediabox-flex"},[_c('div',{staticClass:"auth-form__mediabox-part auth-form__mediabox-part_image helpers_hide_tablet"},[_c('div',{staticClass:"auth-form__preview"},[_c('div',{staticClass:"auth-form__image auth-form__image_shield"})])]),_vm._v(" "),_c('div',{staticClass:"auth-form__mediabox-part auth-form__mediabox-part_content"},[_c('div',{staticClass:"auth-form__description auth-form__description_primary auth-form__description_small auth-form__description_condensed-other"},[_vm._v("\n                  Все операции осуществляются через PCI DSS, данные\n                  банковской карты хранятся у сертифицированного\n                  провайдера платежей bePaid\n                ")]),_vm._v(" "),_c('div',{staticClass:"auth-form__preview"},[_c('div',{staticClass:"auth-form__image auth-form__image_payments-additional"})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-form__preview"},[_c('div',{staticClass:"auth-form__image auth-form__image_bepaid"})])}];

  /* style */
  var __vue_inject_styles__$4 = undefined;
  /* scoped */
  var __vue_scope_id__$4 = undefined;
  /* module identifier */
  var __vue_module_identifier__$4 = undefined;
  /* functional template */
  var __vue_is_functional_template__$4 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var PaymentsAddCard = normalizeComponent_1(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    undefined,
    undefined
  );

var script$5 = defineComponent({
    name: 'payments-list',
    components: {
        PaymentsListCard: PaymentsListCard,
        PaymentsListItem: PaymentsListItem,
        PaymentsAddCard: PaymentsAddCard,
    },
    props: {
        paymentMethods: {
            type: Object,
            required: true,
        },
        value: {
            type: Object,
        },
        newCardErrors: {
            type: Array,
            default: function () { return []; },
        },
        isNewCardRulesAccepted: {
            type: Boolean,
        },
        publicKey: {
            type: String,
            required: true,
        },
        hide: {
            type: Object,
        },
    },
    computed: {
        selectedMethod: {
            get: function get() {
                return Object.assign({}, this.value);
            },
            set: function set(method) {
                this.$emit('input', method);
            },
        },
        accountLink: function accountLink() {
            return UrlService.secureProjectUrl('profile', 'account/payments');
        },
    },
    methods: {
        getVerificationValue: function getVerificationValue(callback) {
            var card = "card_" + (this.selectedMethod.fields.id);
            this.$refs[card][0].getVerificationValue(callback);
        },
        validateCard: function validateCard(id) {
            return this.$refs[("card_" + id)][0].validate();
        },
        validateNewCard: function validateNewCard() {
            return this.$refs.addCard.validateCard();
        },
        getNewCardData: function getNewCardData(callback) {
            this.$refs.addCard.getCardData(callback);
        },
        onAcceptedChanged: function onAcceptedChanged(value) {
            this.$emit('new-card-accepted-change', value);
        },
    },
});

/* script */
var __vue_script__$5 = script$5;

/* template */
var __vue_render__$5 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-subscription"},[_c('div',{staticClass:"auth-form"},[_vm._t("header"),_vm._v(" "),(_vm.paymentMethods.cards.length)?_c('div',{staticClass:"auth-form__description auth-form__description_primary auth-form__description_base auth-form__description_font-weight_semibold"},[_vm._v("\n      Привязанные карты (Onlíner Pay)\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"auth-form__choise auth-form__choise_alter"},[_c('div',{staticClass:"auth-form__choise-list"},[_vm._l((_vm.paymentMethods.cards),function(card){return _c('payments-list-card',{key:card.fields.id,ref:("card_" + (card.fields.id)),refInFor:true,attrs:{"card":card,"public-key":_vm.publicKey,"hide":_vm.hide},model:{value:(_vm.selectedMethod),callback:function ($$v) {_vm.selectedMethod=$$v;},expression:"selectedMethod"}})}),_vm._v(" "),(_vm.paymentMethods.newCardMethod)?_c('payments-add-card',{ref:"addCard",attrs:{"public-key":_vm.publicKey,"method":_vm.paymentMethods.newCardMethod,"errors":_vm.newCardErrors,"is-rules-accepted":_vm.isNewCardRulesAccepted},on:{"accepted-change":_vm.onAcceptedChanged},model:{value:(_vm.selectedMethod),callback:function ($$v) {_vm.selectedMethod=$$v;},expression:"selectedMethod"}}):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"auth-form__choise-list"},[(_vm.paymentMethods.accountMethod)?_c('payments-list-item',{attrs:{"method":_vm.paymentMethods.accountMethod},model:{value:(_vm.selectedMethod),callback:function ($$v) {_vm.selectedMethod=$$v;},expression:"selectedMethod"}},[_c('template',{slot:"fee"}),_vm._v(" "),_c('template',{slot:"subheader"},[_c('div',{staticClass:"auth-form__description auth-form__description_other auth-form__description_tiny auth-form__description_condensed"},[_vm._v("\n              Вы можете пополнить счет Onlíner с помощью системы\n              «Расчет» (ЕРИП), безналичного расчета или SMS\n            ")]),_vm._v(" "),_c('div',{staticClass:"auth-form__description auth-form__description_tiny"},[_c('a',{staticClass:"auth-form__link auth-form__link_primary auth-form__link_tiny",attrs:{"target":"__blank","href":_vm.accountLink}},[_vm._v("\n                Пополнить счет\n              ")])])]),_vm._v(" "),_c('template',{slot:"description"},[_vm._v("Вы можете пополнить счет с помощью банковской карты,\n            через систему «Расчет» (ЕРИП) или SMS. Если\n            на счету недостаточно средств, вас перенаправит\n            на страницу пополнения счета Onlíner.")])],2):_vm._e()],1)])],2)])};
var __vue_staticRenderFns__$5 = [];

  /* style */
  var __vue_inject_styles__$5 = undefined;
  /* scoped */
  var __vue_scope_id__$5 = undefined;
  /* module identifier */
  var __vue_module_identifier__$5 = undefined;
  /* functional template */
  var __vue_is_functional_template__$5 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var list = normalizeComponent_1(
    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
    __vue_inject_styles__$5,
    __vue_script__$5,
    __vue_scope_id__$5,
    __vue_is_functional_template__$5,
    __vue_module_identifier__$5,
    undefined,
    undefined
  );

var keys = {
    esc: 27,
    space: 32,
    enter: 13,
};

var modifiers = {
    bodyStatePopupOpened: 'body_state-auth-popup_opened',
};
var script$6 = defineComponent({
    name: 'popup-modal',
    props: {
        classes: {
            type: Array,
            required: true,
        },
        hasClose: {
            type: Boolean,
            default: true,
        },
    },
    data: function data() {
        return {
            body: $$1('body'),
            document: $$1(document),
            window: $$1(window),
            isOpened: false,
            $popup: null,
        };
    },
    mounted: function mounted() {
        this.$popup = $$1(this.$refs.popup);
        $$1(this.$el).appendTo('body');
        this.subscribeEvents();
    },
    beforeDestroy: function beforeDestroy() {
        this.closePopup();
        $$1(this.$el).remove();
    },
    methods: {
        updatePopupPosition: function updatePopupPosition() {
            var this$1 = this;

            setTimeout(function () {
                this$1.$popup.css({
                    top: (this$1.window.height() - this$1.$popup.outerHeight()) / 2,
                });
            }, 0);
        },
        closePopup: function closePopup() {
            this.$emit('popup:closed');
            this.isOpened = false;
            this.body.removeClass(modifiers.bodyStatePopupOpened);
        },
        openPopup: function openPopup() {
            this.isOpened = true;
            this.body.addClass(modifiers.bodyStatePopupOpened);
        },
        subscribeEvents: function subscribeEvents() {
            var this$1 = this;

            this.document.on('keydown', function (event) {
                event.which === keys.esc && this$1.closePopup();
            });
            this.window.on('orientationchange', function () {
                this$1.closePopup();
            });
        },
        onContainerClick: function onContainerClick(event) {
            if (event.target.contains(this.$refs.popup)) {
                this.closePopup();
            }
        },
    },
});

/* script */
var __vue_script__$6 = script$6;

/* template */
var __vue_render__$6 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-popup__container",class:{ 'auth-popup__container_visible': _vm.isOpened },on:{"click":_vm.onContainerClick}},[_c('div',{staticClass:"auth-popup__overlay auth-popup__overlay_primary",on:{"click":_vm.closePopup}}),_vm._v(" "),_c('div',{ref:"popup",staticClass:"auth-popup",class:_vm.classes},[(_vm.hasClose)?_c('span',{staticClass:"auth-popup__close",on:{"click":_vm.closePopup}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"auth-popup__content"},[_vm._t("default")],2)])])};
var __vue_staticRenderFns__$6 = [];

  /* style */
  var __vue_inject_styles__$6 = undefined;
  /* scoped */
  var __vue_scope_id__$6 = undefined;
  /* module identifier */
  var __vue_module_identifier__$6 = undefined;
  /* functional template */
  var __vue_is_functional_template__$6 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var popup = normalizeComponent_1(
    { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
    __vue_inject_styles__$6,
    __vue_script__$6,
    __vue_scope_id__$6,
    __vue_is_functional_template__$6,
    __vue_module_identifier__$6,
    undefined,
    undefined
  );

var ModalCoreMixin = defineComponent({
    name: 'modal-core',
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    data: function data() {
        return {
            isVisible: false,
            scrollPosition: 0,
            pristineTrigger: false,
        };
    },
    mounted: function mounted() {
        $$1(this.$refs.modal).appendTo('body');
        this.initGlobal();
        this.initEvents();
    },
    beforeDestroy: function beforeDestroy() {
        this._hide();
        $$1(this.$refs.modal).remove();
    },
    methods: {
        _show: function _show() {
            var this$1 = this;

            this.scrollPosition = $$1(window).scrollTop();
            if (!this.isVisible) {
                this.pristineTrigger = false;
                this.$nextTick(function () {
                    this$1.pristineTrigger = true;
                });
            }
            window.hideModals();
            this.isVisible = true;
            $$1(window).scrollTop(0);
        },
        _hide: function _hide(emit) {
            if ( emit === void 0 ) emit = true;

            $$1('body').removeClass('modal-visible');
            if (!this.isVisible) {
                return;
            }
            this.isVisible = false;
            $$1(window).scrollTop(this.scrollPosition);
            emit && this.$emit('modal-close');
        },
        initEvents: function initEvents() {
            var this$1 = this;

            $$1(document).on('keydown', function (event) {
                event.which === keys$1.esc && this$1._hide();
            });
            $$1(window).on('orientationchange', function () {
                this$1._hide();
            });
        },
        initGlobal: function initGlobal() {
            var win = window;
            if (!win.hideModals) {
                win.modals = [this];
                win.hideModals = function () {
                    win.modals.forEach(function (modal) { return modal.hide(false); });
                };
            }
            else {
                win.modals.push(this);
            }
        },
    },
});

var script$7 = defineComponent({
    name: 'secure-3d',
    mixins: [ModalCoreMixin],
    props: {
        src: {
            type: String,
            required: true,
        },
        styles: {
            type: Object,
        },
    },
    mounted: function mounted() {
        this.show();
        window.onSecureClose = this.hide.bind(this);
    },
    methods: {
        show: function show() {
            this._show();
            $('body').addClass('modal-visible');
        },
        hide: function hide(data) {
            this._hide();
            this.$root.$emit('secure:closed', data);
        },
    },
});

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}
var HEAD = document.head || document.getElementsByTagName('head')[0];
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) { style.element.setAttribute('media', css.media); }
      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) { style.element.removeChild(nodes[index]); }
      if (nodes.length) { style.element.insertBefore(textNode, nodes[index]); }else { style.element.appendChild(textNode); }
    }
  }
}

var browser = createInjector;

/* script */
var __vue_script__$7 = script$7;

/* template */
var __vue_render__$7 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"modal",staticClass:"modal",class:{ modal_open: _vm.isVisible },style:(_vm.styles),attrs:{"role":"dialog","aria-hidden":"true"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.hide.apply(null, arguments)}}},[(_vm.isVisible)?_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('iframe',{attrs:{"src":_vm.src,"width":"100%","height":"100%"}})])]):_vm._e()])};
var __vue_staticRenderFns__$7 = [];

  /* style */
  var __vue_inject_styles__$7 = function (inject) {
    if (!inject) { return }
    inject("data-v-0bc8126b_0", { source: ".modal-content[data-v-0bc8126b]{height:100vh}", map: undefined, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$7 = "data-v-0bc8126b";
  /* module identifier */
  var __vue_module_identifier__$7 = undefined;
  /* functional template */
  var __vue_is_functional_template__$7 = false;
  /* style inject SSR */
  

  
  var secure3d = normalizeComponent_1(
    { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
    __vue_inject_styles__$7,
    __vue_script__$7,
    __vue_scope_id__$7,
    __vue_is_functional_template__$7,
    __vue_module_identifier__$7,
    browser,
    undefined
  );

function float (value, floatLength, maxDecimal) {
    if (value === '.' || value === ',') {
        return '0.';
    }
    var valueString = value.toString().replace(',', '.');
    if (/^\d+\.0*0$/.test(valueString)) {
        var floatLength$1 = Math.min(valueString.split('.').pop().length, 2);
        return parseFloat(valueString).toFixed(floatLength$1);
    }
    var floatValue = parseFloat(valueString.replace(/[^\d\.]/g, ''));
    if (isNaN(floatValue)) {
        return '';
    }
    var ref = floatValue
        .toString()
        .replace(',', '.')
        .split('.');
    var decimal = ref[0];
    var float = ref[1];
    var hasDot = value.toString().indexOf('.') !== -1;
    return (decimal.substr(0, maxDecimal) +
        (hasDot ? '.' : '') +
        (float ? float.slice(0, floatLength) : ''));
}

var script$8 = defineComponent({
    name: 'number-input',
    props: {
        placeholder: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            required: true,
        },
        floatSize: {
            type: Number,
            default: 2,
        },
        maxDecimal: {
            type: Number,
            required: true,
        },
    },
    computed: {
        inputValue: {
            get: function get() {
                return this.value;
            },
            set: function set(value) {
                this.$emit('input', this.getValue(value));
            },
        },
    },
    methods: {
        getValue: function getValue(value) {
            var newValue = float(value.replace(',', '.'), this.floatSize, this.maxDecimal);
            return isNaN$1(newValue) ? '' : newValue;
        },
        onInput: function onInput(event) {
            event.target.value = this.getValue(event.target.value).toString();
        },
        getInputValue: function getInputValue() {
            return this.$refs.input.value;
        },
    },
});

/* script */
var __vue_script__$8 = script$8;

/* template */
var __vue_render__$8 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputValue),expression:"inputValue"}],ref:"input",attrs:{"placeholder":_vm.placeholder},domProps:{"value":(_vm.inputValue)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputValue=$event.target.value;},_vm.onInput]}})};
var __vue_staticRenderFns__$8 = [];

  /* style */
  var __vue_inject_styles__$8 = undefined;
  /* scoped */
  var __vue_scope_id__$8 = undefined;
  /* module identifier */
  var __vue_module_identifier__$8 = undefined;
  /* functional template */
  var __vue_is_functional_template__$8 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var NumberInput = normalizeComponent_1(
    { render: __vue_render__$8, staticRenderFns: __vue_staticRenderFns__$8 },
    __vue_inject_styles__$8,
    __vue_script__$8,
    __vue_scope_id__$8,
    __vue_is_functional_template__$8,
    __vue_module_identifier__$8,
    undefined,
    undefined
  );

var TheMask$2 = require('vue-the-mask').TheMask;
var defaultType$1 = {
    code: {
        size: 3,
        name: 'CVV',
    },
    placeholder: '000',
};
var script$9 = defineComponent({
    name: 'cards-list-card',
    components: {
        TheMask: TheMask$2,
        NumberInput: NumberInput,
    },
    props: {
        value: {
            type: String,
        },
        sum: {
            type: String,
        },
        card: {
            type: Object,
            required: true,
        },
        publicKey: {
            type: String,
            required: true,
        },
        errors: {
            type: Object,
            required: true,
        },
    },
    data: function data() {
        return {
            type: defaultType$1,
            cvcNumber: '',
            cvcError: '',
        };
    },
    created: function created() {
        this.type = this.getCardType();
    },
    computed: {
        cardId: {
            get: function get() {
                return this.value;
            },
            set: function set(value) {
                this.$emit('input', value);
            },
        },
        paymentSum: {
            get: function get() {
                return this.sum;
            },
            set: function set(value) {
                this.$emit('sum-change', value);
            },
        },
    },
    watch: {
        value: function value(value$1) {
            if (value$1 === this.card.id) {
                this.$emit('sum-change', this.$refs.sum.getInputValue());
            }
        },
    },
    methods: {
        onCvcInput: function onCvcInput() {
            this.cvcError = '';
        },
        getCardType: function getCardType() {
            var type = map[this.card.brand];
            if (!type) {
                return defaultType$1;
            }
            var ccType = creditCardType.types[type.typeCode];
            return ccType ? creditCardType.getTypeInfo(ccType) : defaultType$1;
        },
        validate: function validate() {
            if (!this.cvcNumber) {
                this.cvcError = 'Введите CVC/CVV';
                return false;
            }
            if (this.cvcNumber.length !== this.type.code.size ||
                !/^\d+$/.test(this.cvcNumber)) {
                this.cvcError = 'Некорректный код';
                return false;
            }
            return true;
        },
        getVerificationValue: function getVerificationValue(callback) {
            if (!this.validate()) {
                this.scrollToError();
                return;
            }
            callback(this.cvcNumber);
        },
        scrollToError: function scrollToError() {
            this.$nextTick(function () {
                var anchor = document.querySelector('.input-style_error');
                anchor && anchor.scrollIntoView();
            });
        },
    },
});

/* script */
var __vue_script__$9 = script$9;

/* template */
var __vue_render__$9 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"auth-form__choise-unit",class:{ 'auth-form__choise-unit_alter': _vm.card.isExpired }},[_c('div',{staticClass:"auth-checkbox auth-checkbox_radio auth-checkbox_success auth-form__checkbox auth-form__checkbox_base",class:{ 'auth-checkbox_disabled': _vm.card.isExpired }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cardId),expression:"cardId"}],staticClass:"auth-checkbox__real",attrs:{"type":"radio","checked":"checked","name":"card","disabled":_vm.card.isExpired},domProps:{"value":_vm.card.id,"checked":_vm._q(_vm.cardId,_vm.card.id)},on:{"change":function($event){_vm.cardId=_vm.card.id;}}}),_vm._v(" "),_c('span',{staticClass:"auth-checkbox__faux"}),_vm._v(" "),_c('div',{staticClass:"auth-form__choise-item",class:{ 'auth-form__choise-item_disabled': _vm.card.isExpired }},[_c('div',{staticClass:"auth-form__choise-header"},[_c('div',{staticClass:"auth-form__preview"},[_c('div',{staticClass:"auth-form__image",class:['auth-form__image_' + (_vm.card.cardInfo.logo || 'empty')]})]),_vm._v(" "),_c('div',{staticClass:"auth-form__description auth-form__description_primary auth-form__description_base auth-form__description_condensed"},[_c('span',{staticClass:"auth-form__description auth-form__description_primary auth-form__description_base auth-form__description_font-weight_semibold"},[_vm._v("\n            "+_vm._s(_vm.card.cardInfo.name)+"\n          ")]),_vm._v("\n           • \n          "+_vm._s(_vm.card.last_4)+" \n          "),_c('span',{staticClass:"auth-form__description auth-form__description_tiny",class:[
              _vm.card.isExpired
                ? 'auth-form__description_error'
                : 'auth-form__description_secondary' ]},[_vm._v("\n            до "+_vm._s(_vm.card.expires)+"\n          ")]),_vm._v(" "),(_vm.card.isExpired)?_c('span',{staticClass:"auth-form__description auth-form__description_error auth-form__description_tiny"},[_vm._v("— срок истек")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"auth-form__choise-body",attrs:{"id":("begateway-encrypted-form_" + (_vm.card.cardId))}},[_c('div',{staticClass:"auth-form__cardbox"},[_c('div',{staticClass:"auth-form__row auth-form__row_condensed"},[_c('div',{staticClass:"auth-form__group auth-form__group_wide-alter"},[_c('div',{staticClass:"auth-form__field"},[_c('div',{staticClass:"auth-form__line auth-form__line_condensed"},[_c('div',{staticClass:"auth-input__wrapper auth-form__input-wrapper auth-form__input-wrapper_width_xxssmm auth-form__input-wrapper_narrow auth-form__input-wrapper_nonadaptive"},[_c('number-input',{ref:"sum",staticClass:"auth-input auth-input_primary auth-input_small auth-form__input auth-form__input_width_full",class:{
                        'auth-input_error': _vm.errors['payment.amount'],
                      },attrs:{"type":"text","placeholder":"до 3500","maxDecimal":4},model:{value:(_vm.paymentSum),callback:function ($$v) {_vm.paymentSum=$$v;},expression:"paymentSum"}}),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_c('div',{staticClass:"auth-form__hint auth-form__hint_secondary auth-form__hint_base auth-form__hint_cvc auth-form__hint_extended-alter auth-form__hint_narrow auth-form__hint_nonadaptive"}),_vm._v(" "),_c('div',{staticClass:"auth-input__wrapper auth-form__input-wrapper auth-form__input-wrapper_width_xxxxssss auth-form__input-wrapper_narrow auth-form__input-wrapper_nonadaptive"},[_c('the-mask',{ref:"cvc",staticClass:"auth-input auth-input_primary auth-input_small auth-input_text_center auth-form__input auth-form__input_width_full",class:{ 'input-style_error': _vm.cvcError },attrs:{"type":"password","autocomplete":"cc-csc","mask":[_vm.type.code.size === 3 ? '###' : '####'],"placeholder":_vm.type.code.name,"size":_vm.type.code.size,"maxlength":_vm.type.code.size,"data-encrypted-name":("encrypted_verification_value_" + (_vm.card.cardId))},on:{"input":_vm.onCvcInput},model:{value:(_vm.cvcNumber),callback:function ($$v) {_vm.cvcNumber=$$v;},expression:"cvcNumber"}})],1)]),_vm._v(" "),(_vm.cvcError)?_c('div',{staticClass:"auth-form__description auth-form__description_error auth-form__description_base auth-form__description_fail"},[_c('div',{staticClass:"auth-form__description auth-form__description_error auth-form__description_base auth-form__description_condensed-alter"},[_vm._v("\n                    "+_vm._s(_vm.cvcError)+"\n                  ")])]):_vm._e(),_vm._v(" "),(_vm.errors['payment.amount'])?_c('div',{staticClass:"auth-form__description auth-form__description_error auth-form__description_base"},[_c('div',{staticClass:"auth-form__description auth-form__description_error auth-form__description_base auth-form__description_condensed-alter"},[_vm._v("\n                    "+_vm._s(_vm.errors['payment.amount'].join('. '))+"\n                  ")])]):_vm._e(),_vm._v(" "),_vm._m(1)])])])])])])])])};
var __vue_staticRenderFns__$9 = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-input__helper auth-input__helper_hint_specific auth-input__helper_visible auth-form__input-helper"},[_c('div',{staticClass:"auth-form__hint auth-form__hint_secondary auth-form__hint_base auth-form__hint_extended-alter"},[_vm._v("\n                        р.\n                      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-form__line auth-form__line_condensed"},[_c('div',{staticClass:"auth-form__description auth-form__description_other auth-form__description_tiny auth-form__description_extended-other"},[_vm._v("\n                    Внимание! Банком-эмитентом карты может взиматься комиссия\n                    при переводе\n                  ")])])}];

  /* style */
  var __vue_inject_styles__$9 = undefined;
  /* scoped */
  var __vue_scope_id__$9 = undefined;
  /* module identifier */
  var __vue_module_identifier__$9 = undefined;
  /* functional template */
  var __vue_is_functional_template__$9 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var CardsListCard = normalizeComponent_1(
    { render: __vue_render__$9, staticRenderFns: __vue_staticRenderFns__$9 },
    __vue_inject_styles__$9,
    __vue_script__$9,
    __vue_scope_id__$9,
    __vue_is_functional_template__$9,
    __vue_module_identifier__$9,
    undefined,
    undefined
  );

var script$a = defineComponent({
    name: 'cards-list-new-card',
    components: {
        CardForm: CardForm,
        NumberInput: NumberInput,
    },
    props: {
        value: {
            type: String,
        },
        sum: {
            type: String,
        },
        publicKey: {
            type: String,
            required: true,
        },
        errors: {
            type: Object,
            required: true,
        },
    },
    data: function data() {
        return {
            cardErrors: [],
        };
    },
    computed: {
        cardId: {
            get: function get() {
                return this.value;
            },
            set: function set(value) {
                this.$emit('input', value);
            },
        },
        paymentSum: {
            get: function get() {
                return this.sum;
            },
            set: function set(value) {
                this.$emit('sum-change', value);
            },
        },
    },
    watch: {
        value: function value(value$1) {
            if (value$1 === null) {
                this.$emit('sum-change', this.$refs.sum.getInputValue());
            }
        },
    },
    methods: {
        getData: function getData(callback) {
            var this$1 = this;

            this.$refs.cardForm.getPristineData(function (card) {
                callback(card);
            }, function (errors) {
                this$1.cardErrors = errors;
            });
        },
    },
});

/* script */
var __vue_script__$a = script$a;

/* template */
var __vue_render__$a = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"auth-form__choise-unit"},[_c('div',{staticClass:"auth-checkbox auth-checkbox_radio auth-checkbox_success auth-form__checkbox auth-form__checkbox_base"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cardId),expression:"cardId"}],staticClass:"auth-checkbox__real",attrs:{"type":"radio","checked":"checked","name":"card"},domProps:{"value":null,"checked":_vm._q(_vm.cardId,null)},on:{"change":function($event){_vm.cardId=null;}}}),_vm._v(" "),_c('span',{staticClass:"auth-checkbox__faux"}),_vm._v(" "),_c('div',{staticClass:"auth-form__choise-item"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"auth-form__choise-body"},[_c('div',{staticClass:"auth-form__cardbox auth-form__cardbox_additional"},[_c('card-form',{ref:"cardForm",attrs:{"public-key":_vm.publicKey,"is-compact":true,"is-narrow":true}}),_vm._v(" "),(_vm.cardErrors.length)?_c('div',{staticClass:"auth-form__description auth-form__description_error auth-form__description_base auth-form__description_fail"},_vm._l((_vm.cardErrors.slice(0, 1)),function(error){return _c('div',{staticClass:"auth-form__description auth-form__description_error auth-form__description_base auth-form__description_condensed-alter"},[_vm._v("\n              "+_vm._s(error)+"\n            ")])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"auth-form__row auth-form__row_condensed-other"},[_c('div',{staticClass:"auth-form__group auth-form__group_width_full"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"auth-form__field"},[_c('div',{staticClass:"auth-form__line auth-form__line_condensed"},[_c('div',{staticClass:"auth-input__wrapper auth-form__input-wrapper auth-form__input-wrapper_width_xxssm auth-form__input-wrapper_narrow auth-form__input-wrapper_nonadaptive"},[_c('number-input',{ref:"sum",staticClass:"auth-input auth-input_primary auth-input_base auth-form__input auth-form__input_width_full",class:{
                        'auth-input_error': _vm.errors['payment.amount'],
                      },attrs:{"type":"text","placeholder":"до 3500","maxDecimal":4},model:{value:(_vm.paymentSum),callback:function ($$v) {_vm.paymentSum=$$v;},expression:"paymentSum"}}),_vm._v(" "),_vm._m(2)],1)]),_vm._v(" "),(_vm.errors['payment.amount'])?_c('div',{staticClass:"auth-form__description auth-form__description_error auth-form__description_base"},[_c('div',{staticClass:"auth-form__description auth-form__description_error auth-form__description_base auth-form__description_condensed-alter"},[_vm._v("\n                    "+_vm._s(_vm.errors['payment.amount'].join('. '))+"\n                  ")])]):_vm._e(),_vm._v(" "),_vm._m(3)])])]),_vm._v(" "),_vm._m(4)],1)])])])])};
var __vue_staticRenderFns__$a = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-form__choise-header"},[_c('div',{staticClass:"auth-form__description auth-form__description_primary auth-form__description_base auth-form__description_font-weight_semibold auth-form__description_condensed"},[_vm._v("\n          Новой картой\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-form__label auth-form__label_primary auth-form__label_base auth-form__label_font-weight_semibold auth-form__label_specific"},[_c('div',{staticClass:"auth-form__label-flex"},[_c('div',{staticClass:"auth-form__label-part auth-form__label-part_1"},[_c('div',{staticClass:"auth-form__label-title"},[_vm._v("Сумма пополнения")])]),_vm._v(" "),_c('div',{staticClass:"auth-form__label-part auth-form__label-part_2"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-input__helper auth-input__helper_hint_specific auth-input__helper_visible auth-form__input-helper"},[_c('div',{staticClass:"auth-form__hint auth-form__hint_secondary auth-form__hint_base-alter auth-form__hint_extended"},[_vm._v("\n                        р.\n                      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-form__line auth-form__line_condensed"},[_c('div',{staticClass:"auth-form__description auth-form__description_other auth-form__description_tiny auth-form__description_extended-other"},[_vm._v("\n                    Внимание! Банком-эмитентом карты может взиматься комиссия\n                    при переводе\n                  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-form__mediabox auth-form__mediabox_extended"},[_c('div',{staticClass:"auth-form__mediabox-flex"},[_c('div',{staticClass:"auth-form__mediabox-part auth-form__mediabox-part_image helpers_hide_tablet"},[_c('div',{staticClass:"auth-form__preview"},[_c('div',{staticClass:"auth-form__image auth-form__image_shield"})])]),_vm._v(" "),_c('div',{staticClass:"auth-form__mediabox-part auth-form__mediabox-part_content"},[_c('div',{staticClass:"auth-form__description auth-form__description_primary auth-form__description_small auth-form__description_condensed-other"},[_vm._v("\n                  Все операции осуществляются через PCI DSS, данные банковской\n                  карты хранятся у сертифицированного провайдера платежей\n                  bePaid\n                ")]),_vm._v(" "),_c('div',{staticClass:"auth-form__preview"},[_c('div',{staticClass:"auth-form__image auth-form__image_payments-additional"})])])])])}];

  /* style */
  var __vue_inject_styles__$a = undefined;
  /* scoped */
  var __vue_scope_id__$a = undefined;
  /* module identifier */
  var __vue_module_identifier__$a = undefined;
  /* functional template */
  var __vue_is_functional_template__$a = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var CardsListNewCard = normalizeComponent_1(
    { render: __vue_render__$a, staticRenderFns: __vue_staticRenderFns__$a },
    __vue_inject_styles__$a,
    __vue_script__$a,
    __vue_scope_id__$a,
    __vue_is_functional_template__$a,
    __vue_module_identifier__$a,
    undefined,
    undefined
  );

var script$b = defineComponent({
    name: 'cards-list',
    components: {
        CardsListCard: CardsListCard,
        CardsListNewCard: CardsListNewCard,
    },
    props: {
        cards: {
            type: Array,
            required: true,
        },
        value: {
            type: String,
        },
        sum: {
            type: String,
            required: true,
        },
        publicKey: {
            type: String,
            required: true,
        },
        errors: {
            type: Object,
            required: true,
        },
    },
    computed: {
        cardId: {
            get: function get() {
                return this.value;
            },
            set: function set(value) {
                this.$emit('input', value);
            },
        },
    },
    methods: {
        onSumChange: function onSumChange(value) {
            this.$emit('sum-change', value);
        },
        getVerificationValue: function getVerificationValue(callback) {
            var card = "card_" + (this.cardId);
            this.$refs[card][0].getVerificationValue(callback);
        },
        getNewCardData: function getNewCardData(callback) {
            this.$refs.newCard.getData(function (card) {
                callback(card);
            });
        },
    },
});

/* script */
var __vue_script__$b = script$b;

/* template */
var __vue_render__$b = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-form__choise"},[_c('div',{staticClass:"auth-form__choise-list ym-hide-content"},[_vm._l((_vm.cards),function(card){return _c('cards-list-card',{key:card.id,ref:("card_" + (card.id)),refInFor:true,attrs:{"card":card,"sum":_vm.sum,"publicKey":_vm.publicKey,"errors":_vm.errors},on:{"sum-change":_vm.onSumChange},model:{value:(_vm.cardId),callback:function ($$v) {_vm.cardId=$$v;},expression:"cardId"}})}),_vm._v(" "),_c('cards-list-new-card',{ref:"newCard",attrs:{"sum":_vm.sum,"public-key":_vm.publicKey,"errors":_vm.errors},on:{"sum-change":_vm.onSumChange},model:{value:(_vm.cardId),callback:function ($$v) {_vm.cardId=$$v;},expression:"cardId"}})],2)])};
var __vue_staticRenderFns__$b = [];

  /* style */
  var __vue_inject_styles__$b = undefined;
  /* scoped */
  var __vue_scope_id__$b = undefined;
  /* module identifier */
  var __vue_module_identifier__$b = undefined;
  /* functional template */
  var __vue_is_functional_template__$b = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var CardsList = normalizeComponent_1(
    { render: __vue_render__$b, staticRenderFns: __vue_staticRenderFns__$b },
    __vue_inject_styles__$b,
    __vue_script__$b,
    __vue_scope_id__$b,
    __vue_is_functional_template__$b,
    __vue_module_identifier__$b,
    undefined,
    undefined
  );

var script$c = defineComponent({
    name: 'cobrand-info',
});

/* script */
var __vue_script__$c = script$c;

/* template */
var __vue_render__$c = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)};
var __vue_staticRenderFns__$c = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-form__cardbox-part auth-form__cardbox-part_2"},[_c('div',{staticClass:"auth-form__description auth-form__description_other auth-form__description_tiny auth-form__description_extended-complementary"},[_vm._v("\n    Карта получателя\n  ")]),_vm._v(" "),_c('div',{staticClass:"auth-form__moneyback"},[_c('div',{staticClass:"auth-form__preview"},[_c('div',{staticClass:"auth-form__image auth-form__image_clover auth-form__image_clover_additional"})])])])}];

  /* style */
  var __vue_inject_styles__$c = undefined;
  /* scoped */
  var __vue_scope_id__$c = undefined;
  /* module identifier */
  var __vue_module_identifier__$c = undefined;
  /* functional template */
  var __vue_is_functional_template__$c = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var CobrandInfo = normalizeComponent_1(
    { render: __vue_render__$c, staticRenderFns: __vue_staticRenderFns__$c },
    __vue_inject_styles__$c,
    __vue_script__$c,
    __vue_scope_id__$c,
    __vue_is_functional_template__$c,
    __vue_module_identifier__$c,
    undefined,
    undefined
  );

var script$d = defineComponent({
    name: 'sender-cards',
    components: {
        CardsList: CardsList,
        CobrandInfo: CobrandInfo,
    },
    props: {
        sum: {
            type: String,
        },
        publicKey: {
            type: String,
            required: true,
        },
        cards: {
            type: [Array, Object],
            required: true,
        },
        isProcessing: {
            type: Boolean,
            required: true,
        },
        errors: {
            type: Object,
            required: true,
        },
    },
    data: function data() {
        return {
            selectedCardId: null,
            paymentSum: this.sum || '',
            isRulesAccepted: true,
        };
    },
    created: function created() {
        this.selectedCardId = this.getDefaultCard();
    },
    computed: {
        sumLabel: function sumLabel() {
            return this.paymentSum ? this.paymentSum.replace('.', ',') : '0';
        },
        cardId: {
            get: function get() {
                return this.selectedCardId;
            },
            set: function set(value) {
                this.selectedCardId = value;
            },
        },
    },
    methods: {
        getDefaultCard: function getDefaultCard() {
            if (this.cards.lastUsedId) {
                return this.cards.lastUsedId;
            }
            var cards = this.cards.filter(function (card) { return !card.isExpired; });
            return cards.length ? cards[0].id : null;
        },
        onPay: function onPay() {
            var this$1 = this;

            if (this.selectedCardId) {
                this.$refs.cardsList.getVerificationValue(function (verificationValue) {
                    this$1.$emit('pay', {
                        sum: this$1.paymentSum,
                        cardId: this$1.selectedCardId,
                        verificationValue: verificationValue,
                    });
                });
            }
            else {
                this.$refs.cardsList.getNewCardData(function (card) {
                    this$1.$emit('pay', {
                        sum: this$1.paymentSum,
                        card: card,
                    });
                });
            }
        },
        onSumChange: function onSumChange(value) {
            this.paymentSum = value;
            this.$emit('field-change', 'payment.amount');
        },
    },
});

/* script */
var __vue_script__$d = script$d;

/* template */
var __vue_render__$d = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-form__cardbox auth-form__cardbox_specific"},[_c('div',{staticClass:"auth-form__cardbox-flex"},[_c('div',{staticClass:"auth-form__cardbox-part auth-form__cardbox-part_1"},[_c('div',{staticClass:"auth-form__description auth-form__description_other auth-form__description_tiny auth-form__description_extended-complementary"},[_vm._v("\n        Карта отправителя\n      ")]),_vm._v(" "),_c('cards-list',{ref:"cardsList",attrs:{"cards":_vm.cards,"sum":_vm.sum,"public-key":_vm.publicKey,"errors":_vm.errors},on:{"sum-change":_vm.onSumChange},model:{value:(_vm.cardId),callback:function ($$v) {_vm.cardId=$$v;},expression:"cardId"}})],1),_vm._v(" "),_c('cobrand-info')],1),_vm._v(" "),_c('div',{staticClass:"auth-form__control auth-form__control_condensed-additional"},[_c('span',{staticClass:"auth-button auth-button_primary auth-button_middle auth-form__button auth-form__button_width_full auth-form__button_max-width_sssm",class:{
        'auth-button_disabled': !_vm.isRulesAccepted,
        'auth-button_animated': _vm.isProcessing,
      },on:{"click":_vm.onPay}},[_vm._v("\n      Пополнить на "+_vm._s(_vm.sumLabel)+" р.\n    ")])]),_vm._v(" "),_c('div',{staticClass:"auth-form__row auth-form__row_reverse_condensed"},[_c('div',{staticClass:"auth-form__group auth-form__group_width_full"},[_c('div',{staticClass:"auth-form__field"},[_c('label',{staticClass:"auth-form__checkbox-label"},[_c('span',{staticClass:"auth-checkbox auth-checkbox_success auth-form__checkbox auth-form__checkbox_base"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isRulesAccepted),expression:"isRulesAccepted"}],staticClass:"auth-checkbox__real",attrs:{"type":"checkbox","checked":"checked"},domProps:{"checked":Array.isArray(_vm.isRulesAccepted)?_vm._i(_vm.isRulesAccepted,null)>-1:(_vm.isRulesAccepted)},on:{"change":function($event){var $$a=_vm.isRulesAccepted,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isRulesAccepted=$$a.concat([$$v]));}else {$$i>-1&&(_vm.isRulesAccepted=$$a.slice(0,$$i).concat($$a.slice($$i+1)));}}else {_vm.isRulesAccepted=$$c;}}}}),_vm._v(" "),_c('span',{staticClass:"auth-checkbox__faux"}),_vm._v(" "),_vm._m(0)])])])])])])};
var __vue_staticRenderFns__$d = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"auth-form__checkbox-text"},[_c('span',{staticClass:"auth-form__checkbox-sign"},[_vm._v("Я ознакомлен и согласен с условиями")]),_vm._v(" "),_c('a',{staticClass:"auth-form__link auth-form__link_primary auth-form__link_base",attrs:{"href":"https://www.onliner.by/clever/p2p-offer","target":"_blank"}},[_vm._v("\n                публичной оферты\n              ")])])}];

  /* style */
  var __vue_inject_styles__$d = undefined;
  /* scoped */
  var __vue_scope_id__$d = undefined;
  /* module identifier */
  var __vue_module_identifier__$d = undefined;
  /* functional template */
  var __vue_is_functional_template__$d = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var SenderCards = normalizeComponent_1(
    { render: __vue_render__$d, staticRenderFns: __vue_staticRenderFns__$d },
    __vue_inject_styles__$d,
    __vue_script__$d,
    __vue_scope_id__$d,
    __vue_is_functional_template__$d,
    __vue_module_identifier__$d,
    undefined,
    undefined
  );

var script$e = defineComponent({
    name: 'new-card',
    components: {
        CardForm: CardForm,
        CobrandInfo: CobrandInfo,
        NumberInput: NumberInput,
    },
    inheritAttrs: true,
    props: {
        sum: {
            type: String,
            required: true,
        },
        publicKey: {
            type: String,
            required: true,
        },
        isProcessing: {
            type: Boolean,
            required: true,
        },
        errors: {
            type: Object,
            required: true,
        },
    },
    data: function data() {
        return {
            paymentSum: this.sum || '',
            isRulesAccepted: true,
            cardErrors: [],
        };
    },
    computed: {
        sumLabel: function sumLabel() {
            return this.paymentSum ? this.paymentSum.replace('.', ',') : '0';
        },
    },
    methods: {
        onPay: function onPay() {
            var this$1 = this;

            this.$refs.cardForm.getPristineData(function (card) {
                this$1.$emit('pay', {
                    sum: this$1.paymentSum,
                    card: card,
                });
            }, function (errors) {
                this$1.cardErrors = errors;
            });
        },
        onSumChange: function onSumChange() {
            this.$emit('field-change', 'payment.amount');
        },
    },
});

/* script */
var __vue_script__$e = script$e;

/* template */
var __vue_render__$e = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-form__cardbox auth-form__cardbox_specific"},[_c('div',{staticClass:"auth-form__cardbox-flex"},[_c('div',{staticClass:"auth-form__cardbox-part auth-form__cardbox-part_1"},[_c('div',{staticClass:"auth-form__description auth-form__description_other auth-form__description_tiny auth-form__description_extended-complementary"},[_vm._v("\n        Карта отправителя\n      ")]),_vm._v(" "),_c('card-form',{ref:"cardForm",attrs:{"publicKey":_vm.publicKey}}),_vm._v(" "),(_vm.cardErrors.length)?_c('div',{staticClass:"auth-form__description auth-form__description_error auth-form__description_base auth-form__description_fail"},_vm._l((_vm.cardErrors.slice(0, 1)),function(error){return _c('div',{staticClass:"auth-form__description auth-form__description_error auth-form__description_base auth-form__description_condensed-alter"},[_vm._v("\n          "+_vm._s(error)+"\n        ")])}),0):_vm._e()],1),_vm._v(" "),_c('cobrand-info')],1),_vm._v(" "),_c('div',{staticClass:"auth-form__divider auth-form__divider_condensed-other"}),_vm._v(" "),_c('div',{staticClass:"auth-form__row auth-form__row_condensed-other"},[_c('div',{staticClass:"auth-form__group auth-form__group_width_full"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"auth-form__field"},[_c('div',{staticClass:"auth-form__line auth-form__line_condensed"},[_c('div',{staticClass:"auth-input__wrapper auth-form__input-wrapper auth-form__input-wrapper_width_xxssm auth-form__input-wrapper_narrow auth-form__input-wrapper_nonadaptive"},[_c('number-input',{staticClass:"auth-input auth-input_primary auth-input_base auth-form__input auth-form__input_width_full",class:{ 'auth-input_error': _vm.errors['payment.amount'] },attrs:{"type":"text","placeholder":"до 3500","maxDecimal":4},on:{"input":_vm.onSumChange},model:{value:(_vm.paymentSum),callback:function ($$v) {_vm.paymentSum=$$v;},expression:"paymentSum"}}),_vm._v(" "),_vm._m(1)],1)]),_vm._v(" "),(_vm.errors['payment.amount'])?_c('div',{staticClass:"auth-form__description auth-form__description_error auth-form__description_base"},[_c('div',{staticClass:"auth-form__description auth-form__description_error auth-form__description_base auth-form__description_condensed-alter"},[_vm._v("\n            "+_vm._s(_vm.errors['payment.amount'].join('. '))+"\n          ")])]):_vm._e(),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"auth-form__control auth-form__control_condensed-additional"},[_c('span',{staticClass:"auth-button auth-button_primary auth-button_middle auth-form__button auth-form__button_width_full auth-form__button_max-width_sssm",class:{
        'auth-button_disabled': !_vm.isRulesAccepted,
        'auth-button_animated': _vm.isProcessing,
      },on:{"click":_vm.onPay}},[_vm._v("\n      Пополнить на "+_vm._s(_vm.sumLabel)+" р.\n    ")])]),_vm._v(" "),_c('div',{staticClass:"auth-form__row auth-form__row_reverse_condensed"},[_c('div',{staticClass:"auth-form__group auth-form__group_width_full"},[_c('div',{staticClass:"auth-form__field"},[_c('label',{staticClass:"auth-form__checkbox-label"},[_c('span',{staticClass:"auth-checkbox auth-checkbox_success auth-form__checkbox auth-form__checkbox_base"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isRulesAccepted),expression:"isRulesAccepted"}],staticClass:"auth-checkbox__real",attrs:{"type":"checkbox","checked":"checked"},domProps:{"checked":Array.isArray(_vm.isRulesAccepted)?_vm._i(_vm.isRulesAccepted,null)>-1:(_vm.isRulesAccepted)},on:{"change":function($event){var $$a=_vm.isRulesAccepted,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isRulesAccepted=$$a.concat([$$v]));}else {$$i>-1&&(_vm.isRulesAccepted=$$a.slice(0,$$i).concat($$a.slice($$i+1)));}}else {_vm.isRulesAccepted=$$c;}}}}),_vm._v(" "),_c('span',{staticClass:"auth-checkbox__faux"}),_vm._v(" "),_vm._m(3)])])])])])])};
var __vue_staticRenderFns__$e = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-form__label auth-form__label_primary auth-form__label_base auth-form__label_font-weight_semibold auth-form__label_specific"},[_c('div',{staticClass:"auth-form__label-flex"},[_c('div',{staticClass:"auth-form__label-part auth-form__label-part_1"},[_c('div',{staticClass:"auth-form__label-title"},[_vm._v("Сумма пополнения")])]),_vm._v(" "),_c('div',{staticClass:"auth-form__label-part auth-form__label-part_2"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-input__helper auth-input__helper_hint_specific auth-input__helper_visible auth-form__input-helper"},[_c('div',{staticClass:"auth-form__hint auth-form__hint_secondary auth-form__hint_base-alter auth-form__hint_extended"},[_vm._v("\n                р.\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-form__line auth-form__line_condensed"},[_c('div',{staticClass:"auth-form__description auth-form__description_other auth-form__description_base auth-form__description_extended-other"},[_vm._v("\n            Внимание! Банком-эмитентом карты может взиматься комиссия при\n            переводе\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"auth-form__checkbox-text"},[_c('span',{staticClass:"auth-form__checkbox-sign"},[_vm._v("Я ознакомлен и согласен с условиями")]),_vm._v(" "),_c('a',{staticClass:"auth-form__link auth-form__link_primary auth-form__link_base",attrs:{"href":"https://www.onliner.by/clever/p2p-offer","target":"_blank"}},[_vm._v("\n                публичной оферты\n              ")])])}];

  /* style */
  var __vue_inject_styles__$e = undefined;
  /* scoped */
  var __vue_scope_id__$e = undefined;
  /* module identifier */
  var __vue_module_identifier__$e = undefined;
  /* functional template */
  var __vue_is_functional_template__$e = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var NewCard = normalizeComponent_1(
    { render: __vue_render__$e, staticRenderFns: __vue_staticRenderFns__$e },
    __vue_inject_styles__$e,
    __vue_script__$e,
    __vue_scope_id__$e,
    __vue_is_functional_template__$e,
    __vue_module_identifier__$e,
    undefined,
    undefined
  );

var script$f = defineComponent({
    name: 'refill-result-popup',
    components: {
        Popup: popup
    },
    filters: {
        money: money
    },
    props: {
        paymentData: {
            type: Object,
            required: true
        },
        paymentError: {
            type: String,
            required: true
        },
        paymentResult: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            isActive: false
        };
    },
    mounted: function mounted() {
        this.showPopup();
    },
    methods: {
        showPopup: function showPopup(options) {

            this.isActive = true;
            this.$refs.refillPopup.openPopup();
        },
        closePopup: function closePopup(options) {

            this.isActive = true;
            this.$refs.refillPopup.closePopup();
        },
        onSuccessConfirm: function onSuccessConfirm() {
            this.$emit('success-confirmed', this.paymentData);
            this.closePopup();
        },
        onErrorConfirm: function onErrorConfirm() {
            this.$emit('error-confirmed', this.paymentError);
            this.closePopup();
        },
        onPopupClose: function onPopupClose() {
            this.$emit('close');
            this.isActive = false;
        }
    }
});

/* script */
var __vue_script__$f = script$f;

/* template */
var __vue_render__$f = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popup',{ref:"refillPopup",attrs:{"classes":[
    'auth-popup',
    'auth-popup_primary',
    'auth-popup_middle',
    'auth-popup_width_ll' ]},on:{"popup:closed":_vm.onPopupClose}},[_c('div',{staticClass:"auth-form__create auth-form__create_specific"},[(_vm.paymentResult === 'success')?_c('div',{staticClass:"auth-form__moneyback auth-form__moneyback_decor auth-form__moneyback_decor_additional auth-form__moneyback_decor_additional-success"},[_c('div',{staticClass:"auth-form__preview"},[_c('div',{staticClass:"auth-form__image auth-form__image_clover auth-form__image_clover_other"})]),_vm._v(" "),_c('div',{staticClass:"auth-form__title auth-form__title_base auth-form__title_condensed-complementary"},[_vm._v("\n        + "+_vm._s(_vm._f("money")(_vm.paymentData.paymentAmount))+" р.\n      ")]),_vm._v(" "),_c('div',{staticClass:"auth-form__description auth-form__description_primary auth-form__description_base-alter"},[_vm._v("\n        Пополнение карты выполнено успешно\n      ")]),_vm._v(" "),_c('div',{staticClass:"auth-form__control auth-form__control_condensed-additional"},[_c('a',{staticClass:"auth-button auth-button_primary auth-button_base auth-form__button",on:{"click":_vm.onSuccessConfirm}},[_vm._v("\n          Хорошо, далее\n        ")])])]):_c('div',{staticClass:"auth-form__moneyback auth-form__moneyback_decor auth-form__moneyback_decor_additional auth-form__moneyback_decor_additional-error"},[_c('div',{staticClass:"auth-form__preview"},[_c('div',{staticClass:"auth-form__image auth-form__image_clover auth-form__image_clover_other"})]),_vm._v(" "),_c('div',{staticClass:"auth-form__title auth-form__title_base auth-form__title_condensed-complementary"},[_vm._v("\n        Не удалось пополнить карту\n      ")]),_vm._v(" "),_c('div',{staticClass:"auth-form__description auth-form__description_primary auth-form__description_base-alter"},[_vm._v("\n        "+_vm._s(_vm.paymentError || 'Пожалуйста, попробуйте еще раз')+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"auth-form__control auth-form__control_condensed-additional"},[_c('a',{staticClass:"auth-button auth-button_expletive auth-button_base auth-form__button",on:{"click":_vm.onErrorConfirm}},[_vm._v("\n          Вернуться к пополнению\n        ")])])])])])};
var __vue_staticRenderFns__$f = [];

  /* style */
  var __vue_inject_styles__$f = undefined;
  /* scoped */
  var __vue_scope_id__$f = undefined;
  /* module identifier */
  var __vue_module_identifier__$f = undefined;
  /* functional template */
  var __vue_is_functional_template__$f = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var RefillResultPopup = normalizeComponent_1(
    { render: __vue_render__$f, staticRenderFns: __vue_staticRenderFns__$f },
    __vue_inject_styles__$f,
    __vue_script__$f,
    __vue_scope_id__$f,
    __vue_is_functional_template__$f,
    __vue_module_identifier__$f,
    undefined,
    undefined
  );

var PopoverMixin = defineComponent({
    name: 'popover-mixin',
    data: function data() {
        return {
            popoverBodyClass: undefined,
            isPopoverVisible: false,
        };
    },
    mounted: function mounted() {
        this.attachEvents();
    },
    methods: {
        attachEvents: function attachEvents() {
            var this$1 = this;

            this.$refs.handle.addEventListener('click', function (event) {
                event.stopImmediatePropagation();
            });
            document.addEventListener('click', function () {
                this$1.closePopover();
            });
            document.addEventListener('keydown', function (event) {
                this$1.onKeyDown(event);
            });
        },
        onKeyDown: function onKeyDown(event) {
            if (!this.isPopoverVisible) {
                return;
            }
            if (event.keyCode === keys$1.esc) {
                this.closePopover();
                event.preventDefault();
                return;
            }
            if (event.keyCode === keys$1.enter || event.keyCode === keys$1.space) {
                this.onEnter();
                event.preventDefault();
            }
        },
        onEnter: function onEnter() {
            // empty by default
        },
        onTriggerPopoverClick: function onTriggerPopoverClick() {
            this.togglePopover();
        },
        onCancelClick: function onCancelClick() {
            this.closePopover();
        },
        openPopover: function openPopover() {
            this.isPopoverVisible = true;
            this.popoverBodyClass &&
                window.document.body.classList.add(this.popoverBodyClass);
        },
        closePopover: function closePopover() {
            this.isPopoverVisible = false;
            this.popoverBodyClass &&
                window.document.body.classList.remove(this.popoverBodyClass);
        },
        togglePopover: function togglePopover() {
            this.isPopoverVisible ? this.closePopover() : this.openPopover();
        },
    },
});

var script$g = defineComponent({
    name: 'erip-info',
    mixins: [PopoverMixin],
    methods: {
        onBankingDetailsClick: function onBankingDetailsClick() {
            this.$emit('banking-details-click');
        },
    },
});

/* script */
var __vue_script__$g = script$g;

/* template */
var __vue_render__$g = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-form__description auth-form__description_primary auth-form__description_base auth-form__description_condensed-complementary"},[_c('div',{ref:"handle",staticClass:"auth-popover__handle auth-form__popover-handle"},[_c('div',{staticClass:"auth-popover auth-popover_primary auth-popover_small auth-popover_bottom-left auth-form__popover auth-form__popover_width_lll",class:{ 'auth-popover_visible': _vm.isPopoverVisible }},[_c('div',{staticClass:"auth-popover__content"},[_c('div',{staticClass:"auth-form"},[_c('div',{staticClass:"auth-form__description auth-form__description_primary auth-form__description_base auth-form__description_extended-subsidiary"},[_vm._v("\n            Пополнить карту «Onlíner Клевер» с помощью ЕРИП можно в приложении\n            вашего банка или интернет-банкинге:\n            "),_c('ol',[_c('li',[_vm._v("\n                Для пополнения карты через ЕРИП вам необходимо знать\n                "),_c('span',{staticClass:"auth-form__description auth-form__description_primary auth-form__description_base auth-form__description_font-weight_semibold"},[_vm._v("номер договора карты")]),_vm._v(". Номер договора можно получить,\n                "),_c('a',{staticClass:"auth-form__link auth-form__link_primary auth-form__link_base",on:{"click":_vm.onBankingDetailsClick}},[_vm._v("запросив реквизиты")]),_vm._v("\n                на странице карты «Onlíner Клевер» в профиле или в мобильном\n                приложении «Каталог Onlíner»\n              ")]),_vm._v(" "),_c('li',[_vm._v("\n                В дереве ЕРИП необходимо пройти следующие шаги: Банковские,\n                финансовые услуги → Банки, НКФО → МТБанк → Пополнение\n                дебетовой карты — и ввести номер договора.\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"auth-form__description auth-form__description_primary auth-form__description_base auth-form__description_condensed"},[_vm._v("\n            Также номер договора можно узнать в\n            "),_c('a',{staticClass:"auth-form__link auth-form__link_primary auth-form__link_base",attrs:{"href":"https://onelink.to/w877e3","target":"__blank"}},[_c('nobr',[_vm._v("мобильном приложении банка")])],1),_vm._v(". Для этого зайдите на страницу/экран карты\n            «Onlíner Клевер» → в меню «Информация» находятся данные о\n            номере и дате договора.\n          ")])])])]),_vm._v(" "),_c('span',{staticClass:"auth-form__link auth-form__link_primary auth-form__link_base",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.togglePopover.apply(null, arguments)}}},[_vm._v("\n      Как пополнить карту без комиссии?\n    ")])])])};
var __vue_staticRenderFns__$g = [];

  /* style */
  var __vue_inject_styles__$g = undefined;
  /* scoped */
  var __vue_scope_id__$g = undefined;
  /* module identifier */
  var __vue_module_identifier__$g = undefined;
  /* functional template */
  var __vue_is_functional_template__$g = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var eripInfo = normalizeComponent_1(
    { render: __vue_render__$g, staticRenderFns: __vue_staticRenderFns__$g },
    __vue_inject_styles__$g,
    __vue_script__$g,
    __vue_scope_id__$g,
    __vue_is_functional_template__$g,
    __vue_module_identifier__$g,
    undefined,
    undefined
  );

var script$h = defineComponent({
    name: 'refill-form',
    components: {
        EripInfo: eripInfo,
        NewCard: NewCard,
        RefillResultPopup: RefillResultPopup,
        Secure3d: secure3d,
        SenderCards: SenderCards,
    },
    props: {
        sum: {
            type: [Number, String],
        },
        publicKey: {
            type: String,
            required: true,
        },
        withResultPopup: {
            type: Boolean,
            required: false,
        },
    },
    data: function data() {
        return {
            cobrandCard: new CobrandCard({}),
            cards: [],
            isReady: true,
            encryptService: null,
            isPaymentInProcess: false,
            errors: {},
            secure3dUrl: '',
            paymentData: {},
            paymentError: '',
            paymentResult: null,
        };
    },
    computed: {
        filteredCards: function filteredCards() {
            var this$1 = this;

            if (!this.cobrandCard || !this.cobrandCard.card) {
                return [];
            }
            return this.cards.filter(function (card) { return card.id !== this$1.cobrandCard.card.id &&
                !contains(p2pExcludedCards, card.type); });
        },
    },
    created: function created() {
        var this$1 = this;

        this.encryptService = new EncryptService(this.publicKey);
        this.$emit('start-loading');
        paygateApi.getCobrandCard({
            success: function (card) {
                if (!card.card) {
                    this$1.$emit('no-card');
                }
                this$1.cobrandCard = card;
                paygateApi.cards({
                    success: function (cards) {
                        this$1.cards = cards;
                        this$1.isReady = true;
                        this$1.$emit('ready');
                    },
                });
            },
            error: function () {
                this$1.$emit('no-card');
            },
        });
    },
    methods: {
        onPay: function onPay(ref) {
            var sum = ref.sum;
            var card = ref.card;
            var cardId = ref.cardId;
            var verificationValue = ref.verificationValue; if ( verificationValue === void 0 ) verificationValue = null;

            this.isPaymentInProcess = true;
            var formattedSum = parseFloat(sum || '0').toFixed(2);
            if (cardId) {
                this.payByCard({ sum: formattedSum, cardId: cardId, verificationValue: verificationValue });
            }
            else if (card) {
                this.payByNewCard({ sum: formattedSum, card: card });
            }
        },
        payByCard: function payByCard(ref) {
            var this$1 = this;
            var sum = ref.sum;
            var cardId = ref.cardId;
            var verificationValue = ref.verificationValue;

            paygateApi.refillByCard({
                senderCard: {
                    id: cardId,
                    verificationValue: verificationValue && this.encryptService
                        ? this.encryptService.encrypt(verificationValue)
                        : null,
                },
                recipientCard: {
                    id: this.cobrandCard.card.id,
                },
                payment: {
                    amount: sum || 0,
                    currency: 'BYN',
                },
            }, {
                success: function (data) {
                    this$1.confirmTransaction(data.id);
                },
                error: function (responseData) {
                    var ref = responseData.response;
                    var status = ref.status;
                    var data = ref.data;
                    if (status === 422) {
                        this$1.errors = data.errors;
                        this$1.isPaymentInProcess = false;
                        this$1.scrollToError();
                    }
                    else {
                        this$1.onError(data.detail);
                    }
                },
            });
        },
        payByNewCard: function payByNewCard(ref) {
            var this$1 = this;
            var sum = ref.sum;
            var card = ref.card;

            paygateApi.refillByNewCard({
                senderCard: this.encryptService && this.encryptService.encryptObject(card),
                recipientCard: {
                    id: this.cobrandCard.card.id,
                },
                payment: {
                    amount: sum || 0,
                    currency: 'BYN',
                },
            }, {
                success: function (data) {
                    this$1.confirmTransaction(data.id);
                },
                error: function (responseData) {
                    var ref = responseData.response;
                    var status = ref.status;
                    var data = ref.data;
                    if (status === 422) {
                        this$1.errors = data.errors;
                        this$1.isPaymentInProcess = false;
                        this$1.scrollToError();
                    }
                    else {
                        this$1.onError(data.detail);
                    }
                },
            });
        },
        confirmTransaction: function confirmTransaction(id) {
            var this$1 = this;

            window.addEventListener('message', this.onTransaction, false);
            paygateApi.confirmTransaction(id, {
                success: function (data) {
                    this$1.secure3dUrl = data.authorizationUrl;
                },
                error: function () {
                    this$1.onError();
                },
            });
        },
        onTransaction: function onTransaction(ref) {
            var this$1 = this;
            var data = ref.data;
            var origin = ref.origin;

            if (data.type === 'p2p:3ds' &&
                origin.indexOf(UrlService.baseDomain) !== -1) {
                this.paymentData = data;
                if (data.errorMessage) {
                    var error = decodeURI(data.errorMessage).replace(/\+/g, ' ');
                    this.onError(error);
                }
                else {
                    this.$emit('success', data);
                    if (this.withResultPopup) {
                        this.paymentResult = 'success';
                    }
                }
                window.removeEventListener('message', this.onTransaction);
                this.isPaymentInProcess = false;
                this.$nextTick(function () {
                    this$1.secure3dUrl = '';
                });
            }
        },
        onError: function onError(error) {
            this.paymentError = error || '';
            this.isPaymentInProcess = false;
            this.$emit('error', error);
            if (this.withResultPopup) {
                this.paymentResult = 'error';
            }
        },
        scrollToError: function scrollToError() {
            this.$nextTick(function () {
                var anchor = document.querySelector('.input-style_error, .auth-input_error');
                anchor && anchor.scrollIntoView();
            });
        },
        onSuccessConfirmed: function onSuccessConfirmed(data) {
            this.$emit('success-confirmed', data);
        },
        onErrorConfirmed: function onErrorConfirmed(error) {
            this.$emit('error-confirmed', error);
        },
        onResultsClose: function onResultsClose() {
            this.paymentResult = null;
        },
        onFieldChange: function onFieldChange(fieldName) {
            this.errors = Utilities.removeProp(this.errors, fieldName);
        },
    },
});

/* script */
var __vue_script__$h = script$h;

/* template */
var __vue_render__$h = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-form__body-flex"},[(!_vm.isReady)?_c('div',{staticClass:"auth-form__body-part auth-form__body-part_animated auth-form__body-part_1"}):_c('div',{staticClass:"auth-form__body-part auth-form__body-part_1"},[_c('div',{staticClass:"auth-form__mediabox auth-form__mediabox_success auth-form__mediabox_extended-alter"},[_c('div',{staticClass:"auth-form__mediabox-flex"},[_vm._t("header")],2)]),_vm._v(" "),(_vm.isReady)?[(_vm.filteredCards.length)?_c('sender-cards',{attrs:{"public-key":_vm.publicKey,"sum":_vm.sum,"cards":_vm.filteredCards,"errors":_vm.errors,"is-processing":_vm.isPaymentInProcess},on:{"pay":_vm.onPay,"field-change":_vm.onFieldChange}}):_c('new-card',{attrs:{"public-key":_vm.publicKey,"sum":_vm.sum,"errors":_vm.errors,"is-processing":_vm.isPaymentInProcess},on:{"pay":_vm.onPay,"field-change":_vm.onFieldChange}})]:_vm._e()],2),_vm._v(" "),(_vm.isReady)?_c('div',{staticClass:"auth-form__body-part auth-form__body-part_2 helpers_hide_tablet"}):_vm._e(),_vm._v(" "),(_vm.secure3dUrl)?_c('secure-3d',{attrs:{"src":_vm.secure3dUrl}}):_vm._e(),_vm._v(" "),(_vm.paymentResult)?_c('refill-result-popup',{attrs:{"payment-data":_vm.paymentData,"payment-error":_vm.paymentError,"payment-result":_vm.paymentResult},on:{"success-confirmed":function($event){return _vm.$emit('success-confirmed')},"error-confirmed":function($event){return _vm.$emit('error-confirmed')},"close":_vm.onResultsClose}}):_vm._e()],1)};
var __vue_staticRenderFns__$h = [];

  /* style */
  var __vue_inject_styles__$h = undefined;
  /* scoped */
  var __vue_scope_id__$h = undefined;
  /* module identifier */
  var __vue_module_identifier__$h = undefined;
  /* functional template */
  var __vue_is_functional_template__$h = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var refillForm = normalizeComponent_1(
    { render: __vue_render__$h, staticRenderFns: __vue_staticRenderFns__$h },
    __vue_inject_styles__$h,
    __vue_script__$h,
    __vue_scope_id__$h,
    __vue_is_functional_template__$h,
    __vue_module_identifier__$h,
    undefined,
    undefined
  );

var script$i = defineComponent({
    name: 'google-banner',
    props: {
        slotId: {
            type: String,
            required: true,
        },
        params: {
            type: Array,
            required: true,
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
    },
    data: function data() {
        return {
            slot: null,
        };
    },
    created: function created() {
        var this$1 = this;

        if (!window.googletag) {
            window.googletag = { cmd: [] };
        }
        var googletag = window.googletag;
        googletag.cmd.push(function () {
            var windowObject = window;
            !(windowObject.cookieConsent && windowObject.cookieConsent.ads) &&
                googletag.pubads().setPrivacySettings({ nonPersonalizedAds: true });
            if (!this$1.isMobile || window.innerWidth < 640) {
                this$1.slot = googletag
                    .defineSlot.apply(googletag, this$1.params)
                    .addService(googletag.pubads());
                googletag.pubads().enableSingleRequest();
                googletag.pubads().collapseEmptyDivs();
                googletag.pubads().setCentering(true);
                googletag.pubads().disableInitialLoad();
                googletag.enableServices();
                googletag.display(this$1.slotId);
                googletag.pubads().refresh([this$1.slot]);
            }
        });
    },
    beforeDestroy: function beforeDestroy() {
        var googletag = window.googletag;
        googletag.pubads().clear([this.slot]);
        googletag.destroySlots([this.slot]);
    },
});

/* script */
var __vue_script__$i = script$i;

/* template */
var __vue_render__$i = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.slotId}})};
var __vue_staticRenderFns__$i = [];

  /* style */
  var __vue_inject_styles__$i = undefined;
  /* scoped */
  var __vue_scope_id__$i = undefined;
  /* module identifier */
  var __vue_module_identifier__$i = undefined;
  /* functional template */
  var __vue_is_functional_template__$i = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var googleBanner = normalizeComponent_1(
    { render: __vue_render__$i, staticRenderFns: __vue_staticRenderFns__$i },
    __vue_inject_styles__$i,
    __vue_script__$i,
    __vue_scope_id__$i,
    __vue_is_functional_template__$i,
    __vue_module_identifier__$i,
    undefined,
    undefined
  );

//Payments
var PaymentsList = list;
var Popup = popup;
var Secure3d = secure3d;
var Cobrand;
(function (Cobrand) {
    Cobrand.RefillForm = refillForm;
    Cobrand.EripInfo = eripInfo;
})(Cobrand || (Cobrand = {}));
var GoogleBanner = googleBanner;

export { Cobrand, GoogleBanner, PaymentsList, Popup, Secure3d };
//# sourceMappingURL=components.esm.js.map
